<template>
    <div id="top-bar">
        <span class="big-text"> Game Stage: <span class="red-text"> {{ gameStage }} </span> </span>
        <span class="big-text"> Objective: <span class="red-text"> {{ gameObjective.objective }} </span> </span>
        <span> Your Team: <span :class="textColor"> {{ localTeamName }} </span> </span>
        <span v-if="game.gameStage === 'prepStage'">
            <span> Your Status: <span :class="textColor"> {{ game.selfReady ? 'Ready' : 'Not Ready' }} </span> </span>
            <span> Opponent Status: <span :class="textColor"> {{ game.opReady ? 'Ready' : 'Not Ready' }} </span> </span>
        </span>
        <span v-else>
            <span> Turn Player: <span :class="gameStatus.turnPlayer+'-text'"> {{ teamName(gameStatus.turnPlayer) }} </span> </span>
        </span>
    </div>
</template>

<script>
import {gameStageTitles} from '../../scripts/GameVariables.js';

export default {
    inject: ['game', 'gameObjective'],
    computed: {
        gameStage(){
            return gameStageTitles[this.gameStatus.gameStage];
        },
        textColor(){
            return this.game.localTeam + '-text';
        },
        localTeamName(){
            return this.game.localTeam === 'red' ? 'Red' : 'Blue';
        }
    },
    methods: {
        teamName(team){
            return team === 'red' ? 'Red' : 'Blue';
        }
    },
    props: {
        gameStatus: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
#top-bar{
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: auto;
    margin-right: auto;
    background: white;
    width: fit-content;
    padding-left: 10px;
    border-radius: 5px;
    transition: all 0.2s;
}
#top-bar span::selection{
    background: var(--team-red);
    color: white;
}
#top-bar:hover{
    padding-right: 37.5px;
    padding-left: 25px;
}
#top-bar span{
    margin-right: 10px;
}
.big-text{
    font-size: 1.05em;
}
.red-text{
    color: var(--team-red);
}
.blue-text{
    color: var(--team-blue);
}
</style>